import TransferReviewScreen from 'features/feeBasedInstantTransfer/screens/TransferReview/TransferReviewScreen';

export default function TransferReviewDetailsPage() {
  return <TransferReviewScreen />;
}
